import { Box, Collapse, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../../../../../api/hooks/useColors";
import StatusChip from "../../../../../../../../components/chips/StatusChip";
import SvgToIcon from "../../../../../../../../icons/SvgToIcon";
import { RemediationTypeChip } from "../../../../../../../../utils/chipsData";
import {
  getPrettyDate,
  getReadableTime,
  useLocalTime,
} from "../../../../../../../../utils/timestamp";
import { ReactComponent as ChevronDownIcon } from "../../../../../../../stack/environment/icons/chevron-down.svg";
import { ReactComponent as ChevronRightIcon } from "../../../../../../../stack/environment/icons/chevron-right.svg";
import { IntegrationsMapping } from "../../../../../../../stack/integrations/IntegrationsMapping";
import { DotAndLine } from "../../DotAndLine";
import HistoryLogContent from "./HistoryLogContent";

export default function HistoryLogCollapse({
  auditLog,
  remediation,
  isMostRecentLog,
  showTopConnectLine = true,
  showBottomConnectLine = true,
}) {
  const colors = useColors();
  const [collapsed, setCollapsed] = useState(true);
  const showLocalTime = useLocalTime();

  const formattedDate = getPrettyDate(
    auditLog.log_timestamp.timestamp_utc,
    showLocalTime
  );
  const formattedTime = getReadableTime(
    auditLog.log_timestamp.timestamp_utc,
    showLocalTime
  );

  return (
    <Box display="flex" gap={1} paddingLeft={0.5}>
      {/* Date and time */}
      <Box display="flex" minWidth="90px" height="56px" alignItems="center">
        <Box
          display="flex"
          flexDirection="column"
          gap={0}
          width="max-content"
          height="max-content"
        >
          <Typography variant="overline" color={colors.text_primary}>
            {formattedTime}
          </Typography>
          <Typography variant="caption" color={colors.text_secondary}>
            {formattedDate}
          </Typography>
        </Box>
      </Box>
      <DotAndLine
        showTop={showTopConnectLine}
        showBottom={showBottomConnectLine}
        topLineHeight={25}
        bottomLineHeight={collapsed ? 39 : 174}
      />
      <Box
        width="100%"
        display="flex"
        flexDirection="column"
        gap={1}
        border={`1px solid ${colors.divider}`}
        borderRadius="12px"
        padding="16px 16px 8px 8px"
        marginBottom={2}
        sx={{ backgroundColor: colors.common_white }}
      >
        <Box
          display="flex"
          padding="0 0 0px 8px"
          justifyContent="space-between"
        >
          <Box
            height="24px"
            display="flex"
            gap={1}
            alignItems="center"
            onClick={() => setCollapsed((prev) => !prev)}
            sx={{ cursor: "pointer" }}
          >
            <Box display="flex" alignItems="center">
              <SvgToIcon
                IconLogo={collapsed ? ChevronRightIcon : ChevronDownIcon}
                width="24px"
                style={{ color: colors.active }}
              />
              <SvgToIcon
                IconLogo={IntegrationsMapping[remediation.tool].logo}
                width={"40px"}
              />
            </Box>
            <Typography variant="body2" color={colors.text_primary} noWrap>
              {remediation.name}
            </Typography>
          </Box>
          <StatusChip
            circleColor={
              colors[
                RemediationTypeChip["autoRemediationLogStatus"][
                  auditLog.log_type
                ].color + "_dot"
              ]
            }
            label={
              RemediationTypeChip["autoRemediationLogStatus"][auditLog.log_type]
                .label
            }
          />
        </Box>
        <Collapse in={!collapsed}>
          <HistoryLogContent
            auditLog={auditLog}
            remediation={remediation}
            isMostRecentLog={isMostRecentLog}
          />
        </Collapse>
      </Box>
    </Box>
  );
}
